import { User, Users } from 'lucide-react';
import { FOOD_PREFERENCES, MAX_GUESTS } from '../constants/config';

export default function RSVPForm({ formData, foodPreferences, onFormChange, onFoodPrefChange, onSubmit }) {
    return (
        <div className="border-t-2 border-amber-200 pt-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Please RSVP</h3>

            <div className="space-y-6">
                {/* Name */}
                <div>
                    <label className="block text-gray-700 font-semibold mb-2">
                        <User className="w-4 h-4 inline mr-2" />
                        Your Name *
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={onFormChange}
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-amber-500 focus:outline-none text-lg"
                        placeholder="First Name Last Name"
                    />
                </div>

                {/* Number of Guests */}
                <div>
                    <label className="block text-gray-700 font-semibold mb-2">
                        <Users className="w-4 h-4 inline mr-2" />
                        Number of People (including you) *
                    </label>
                    <select
                        name="numberOfGuests"
                        value={formData.numberOfGuests}
                        onChange={onFormChange}
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-amber-500 focus:outline-none text-lg"
                    >
                        {[...Array(MAX_GUESTS)].map((_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {i + 1} Person{i === 0 ? '' : 's'}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Food Preferences */}
                <div className="bg-amber-50 p-6 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-4">
                        🍽️ Food Preferences
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                        Please select food preference for each person
                    </p>

                    <div className="space-y-3">
                        {foodPreferences.map((pref, index) => (
                            <div key={index} className="bg-white p-4 rounded-lg border-2 border-amber-200">
                                <label className="block text-gray-700 font-medium mb-2">
                                    Person {index + 1}
                                </label>
                                <select
                                    value={pref}
                                    onChange={(e) => onFoodPrefChange(index, e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:border-amber-500 focus:outline-none"
                                >
                                    {FOOD_PREFERENCES.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Additional Information */}
                <div>
                    <label className="block text-gray-700 font-semibold mb-2">
                        Additional Information or Special Requirements
                    </label>
                    <textarea
                        name="additionalInfo"
                        value={formData.additionalInfo}
                        onChange={onFormChange}
                        rows="3"
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-amber-500 focus:outline-none"
                        placeholder="Additional dietary restrictions, allergies, or special needs (optional)"
                    />
                </div>

                {/* Submit Button */}
                <button
                    onClick={onSubmit}
                    className="w-full bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl"
                >
                    ✅ Submit RSVP
                </button>
            </div>
        </div>
    );
}